module.exports = __webpack_public_path__ + "static/img/Floor_LightOak.2cfb811.jpg";